import React from "react";
import { Routes, Route } from "react-router-dom";
import "./sass/index.scss";

import {
  NotFound,
  Solutions,
  About,
  FAQ,
  Contact,
  Register,
  Login,
  LayoutETS,
  Blog,
  ForgotPassword,
  ChangePassword,
  Layout,
  Landing,
  Success,
  ResetPassword,
  // ComingSoon,
  RegisterConfirm,
  NewClientPOS,
  ScanIDPOS,
  FormPOS,
  ExchangePhone,
  WaitingApproval,
  ExchangeSuccess,
  ReceiptPOS,
  ScanWallet,
  ExchangeNotApproved,
  TransactionApproved,
  ActivateUserPage,
  KYC_Completed,
  ToU,
  WPP,
  CRMsoon,
} from "@/pages";
import { RoutesPathList } from "@/config/routes/Routes.tsx";
import { isBitramp } from "./utils/utils";
import { useBranding } from "@/hooks/useBranding.tsx";

const App: React.FC = () => {
  // const isLeonextExchange = window.location.hostname === "leonext.exchange";

  useBranding({
    title: isBitramp() ? "Bitramp" : "Leonext",
    favicon: isBitramp() ? "/f-144x144b.svg" : "/f-144x144.png",
    prefix: "",
    suffix: "",
  });

  return (
    <Layout>
      {/* {isLeonextExchange ? (
        <Routes>
          <Route path="*" element={<ComingSoon />} />
        </Routes>
      ) : ( */}
      <Routes>
        <Route path="/" element={isBitramp() ? <Login /> : <Landing />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register-confirm" element={<RegisterConfirm />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<LayoutETS />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/success" element={<Success />} />
        <Route path="/tou" element={<ToU />} />
        <Route path="/wpp" element={<WPP />} />
        <Route path="/crmSoon" element={<CRMsoon />} />
        <Route
          path={RoutesPathList.ForgotPassword}
          element={<ForgotPassword />}
        />
        <Route
          path={RoutesPathList.ChangePassword}
          element={<ChangePassword />}
        />
        <Route
          path={RoutesPathList.RESET_PASSWORD}
          element={<ResetPassword />}
        />
        <Route path={RoutesPathList.NewClientPOS} element={<NewClientPOS />} />
        <Route path={RoutesPathList.NewClientSNS} element={<NewClientPOS />} />
        <Route path={RoutesPathList.ScanIDPOS} element={<ScanIDPOS />} />
        <Route path={RoutesPathList.ScanIDSNS} element={<ScanIDPOS />} />
        <Route path={RoutesPathList.FormPOS} element={<FormPOS />} />
        <Route path={RoutesPathList.FormSNS} element={<FormPOS />} />
        <Route
          path={RoutesPathList.ExchangePhone}
          element={<ExchangePhone />}
        />
        <Route path={RoutesPathList.ExchangeSNS} element={<ExchangePhone />} />
        <Route
          path={RoutesPathList.WaintingApproval}
          element={<WaitingApproval />}
        />
        <Route
          path={RoutesPathList.WaintingApprovalSNS}
          element={<WaitingApproval />}
        />
        <Route
          path={RoutesPathList.ExchangeSuccess}
          element={<ExchangeSuccess />}
        />
        <Route
          path={RoutesPathList.ExchangeSNSSuccess}
          element={<ExchangeSuccess />}
        />
        <Route path={RoutesPathList.ReceiptPOS} element={<ReceiptPOS />} />
        <Route path={RoutesPathList.ReceiptSNS} element={<ReceiptPOS />} />
        <Route path={RoutesPathList.ScanWallet} element={<ScanWallet />} />
        <Route path={RoutesPathList.ScanWalletSNS} element={<ScanWallet />} />
        <Route
          path={RoutesPathList.ExchangeNotApproved}
          element={<ExchangeNotApproved />}
        />
        <Route
          path={RoutesPathList.ExchangeNotApprovedSNS}
          element={<ExchangeNotApproved />}
        />
        <Route
          path={RoutesPathList.TransactionApproved}
          element={<TransactionApproved />}
        />
        <Route
          path={RoutesPathList.TransactionApprovedSNS}
          element={<TransactionApproved />}
        />
        <Route path="*" element={<NotFound />} />
        <Route
          path="/activate-user/activate/*"
          element={<ActivateUserPage />}
        />
        <Route path="/pos/login" element={<Login />} />
        <Route path={RoutesPathList.SNSLogin} element={<Login />} />
        <Route path={RoutesPathList.KYC} element={<KYC_Completed />} />
        <Route path={RoutesPathList.KYCPOS} element={<KYC_Completed />} />
      </Routes>
    </Layout>
  );
};

export default App;
